import React, { useCallback, type FC } from 'react';
import { isJsmVirtualAgentOnPortalEAPAvailable } from 'feature-flags';
import { Inline, xcss } from '@atlaskit/primitives';
import { useActions } from '../../../controllers/conversation-store';
import type { Appendix as AppendixType, Option } from '../../types';
import { JiraFieldAppendix } from './jira-field-appendices';
import { OptionButton } from './option-button';
import { OptionDropdown } from './option-dropdown';

const Appendix: FC<{ appendix: AppendixType }> = ({ appendix }) => {
    const { selectOption } = useActions();

    const handleSelectOption = useCallback(
        (selectedOption: Option) => {
            selectOption(selectedOption);
        },
        [selectOption]
    );

    switch (appendix.type) {
        case 'JIRA_FIELD':
            return <JiraFieldAppendix appendix={appendix} />;
        case 'OPTION':
            return (
                <>
                    {appendix.options.map((option) => (
                        <OptionButton key={option.id} option={option} />
                    ))}
                </>
            );
        case 'DROPDOWN':
            return <OptionDropdown options={appendix.options} onSelectOption={handleSelectOption} />;
        default:
            return <></>;
    }
};

export const Appendices: FC<{ appendices?: AppendixType[] }> = ({ appendices }) => {
    if (!appendices?.length) {
        return null;
    }

    return (
        <Inline
            space="space.100"
            testId="virtual-agent-appendices"
            xcss={!isJsmVirtualAgentOnPortalEAPAvailable() && appendicesWrapperEnd}
        >
            {appendices.map((appendix) => (
                <Appendix key={appendix.id} appendix={appendix} />
            ))}
        </Inline>
    );
};

const appendicesWrapperEnd = xcss({
    alignSelf: 'flex-end',
});
